export const CREATE_CHECKOUT_SESSION_ATTEMPT = 'CREATE_CHECKOUT_SESSION_ATTEMPT';
export const CREATE_CHECKOUT_SESSION_SUCCESS = 'CREATE_CHECKOUT_SESSION_SUCCESS';
export const CREATE_CHECKOUT_SESSION_FAILURE = 'CREATE_CHECKOUT_SESSION_FAILURE';
export const CLEAR_CHECKOUT_SESSION_STATE = 'CLEAR_CHECKOUT_SESSION_STATE';
